export default __webpack_public_path__ + "static/media/Notifications_WStore.5967fdf8.svg";